import React from "react";
import { Table } from "reactstrap";
import style from "./Grid.module.scss";
import { FormattedDate } from "react-intl";
import { CircularProgress } from "../..";

const Grid = ({ reports, actions }) => {
  const view = (report) => {
    actions.toggleModal(report);
  };

  const DisplayReportsList = () => {
    if (!reports) {
      return <EmptyTable loading />;
    }
    if (reports.length === 0) {
      return <EmptyTable loading={false} />;
    }
    return reports.map((r) => {
      return (
        <tr key={`r-${r.DynamicReportId}`}>
          <td onClick={() => view(r)}>{`${r.DynamicReportName}`}</td>
          <td onClick={() => view(r)}>
            <FormattedDate value={r.DynamicReportLastRuntime} />
          </td>
          <td onClick={() => view(r)}>{r.DynamicReportUserLast}</td>
        </tr>
      );
    });
  };

  return (
    <div className={`content ${style.desk}`}>
      <Table className={style.table} striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Last Runtime</th>
            <th>User</th>
          </tr>
        </thead>
        <tbody>
          <DisplayReportsList />
        </tbody>
      </Table>
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="10" className="text-center mt-5 pt-5 bg-white">
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No dynamic reports</h4>
      )}
    </td>
  </tr>
);

export default Grid;
